import { render, staticRenderFns } from "./Addproductissues.vue?vue&type=template&id=75459f9c"
import script from "./Addproductissues.vue?vue&type=script&lang=js"
export * from "./Addproductissues.vue?vue&type=script&lang=js"
import style0 from "./Addproductissues.vue?vue&type=style&index=0&id=75459f9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports